import React, { useEffect, useRef } from "react"
import { Link } from "react-router-dom"
import { useAuth } from "../contexts/AuthContext"

const Navbar = () => {
  const { user, logout } = useAuth()
  const dropdownRef = useRef(null)

  // Get user initials for avatar
  const getUserInitials = () => {
    if (!user) return 'U'
    if (user.name) {
      const names = user.name.split(' ')
      if (names.length > 1) {
        return (names[0][0] + names[names.length - 1][0]).toUpperCase()
      }
      return user.name.substring(0, 2).toUpperCase()
    }
    return user.email ? user.email[0].toUpperCase() : 'U'
  }

  // Toggle dropdown
  const toggleDropdown = (e) => {
    e.preventDefault()
    e.stopPropagation()
    if (dropdownRef.current) {
      dropdownRef.current.classList.toggle('active')
    }
  }

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        dropdownRef.current.classList.remove('active')
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [])

  return (
    <div className="nk-header is-light nk-header-fixed is-light">
      <div className="container-xl wide-xl">
        <div className="nk-header-wrap">
          <div className="nk-menu-trigger d-xl-none ms-n1 me-3">
            <button
              type="button"
              className="nk-nav-toggle nk-quick-nav-icon"
              data-target="sidebarMenu"
            >
              <em className="icon ni ni-menu" />
            </button>
          </div>
          <div className="nk-header-brand d-xl-none">
            <Link to="/dashboard" className="logo-link">
              <img
                className="logo-light logo-img"
                src="/assets/images/wg_logo.png"
                srcSet="/assets/images/wg_logo.png 2x"
                alt="logo"
              />
              <img
                className="logo-dark logo-img"
                src="/assets/images/logo-dark.png"
                srcSet="/assets/images/wg_logo.png 2x"
                alt="logo-dark"
              />
            </Link>
          </div>
          <div className="nk-header-menu is-light">
            <div className="nk-header-menu-inner">
              <ul className="nk-menu nk-menu-main">
                    <li className="nk-menu-item">
                        <Link to="/dashboard" className="nk-menu-link">
                          <span className="nk-menu-text">Home</span>
                        </Link>
                      </li>
                      <li className="nk-menu-item has-sub">
                        <Link to="/users" className="nk-menu-link nk-menu-toggle">
                          <span className="nk-menu-text">Customers</span>
                        </Link>
                        <ul className="nk-menu-sub">
                          <li className="nk-menu-item">
                            <Link to="/users" className="nk-menu-link">
                              <span className="nk-menu-text">All</span>
                            </Link>
                          </li>
                          <li className="nk-menu-item">
                            <Link to="/winners" className="nk-menu-link">
                              <span className="nk-menu-text">Winners</span>
                            </Link>
                          </li>
                         
                        </ul>
                      </li>
                      <li className="nk-menu-item has-sub">
                        <Link to="/all-transactions" className="nk-menu-link nk-menu-toggle">
                          <span className="nk-menu-text">Receipts</span>
                        </Link>
                        <ul className="nk-menu-sub">
                          <li className="nk-menu-item">
                            <Link to="/all-transactions" className="nk-menu-link">
                              <span className="nk-menu-text">All</span>
                            </Link>
                          </li>
                          <li className="nk-menu-item">
                            <Link to="/pending-transactions" className="nk-menu-link">
                              <span className="nk-menu-text">Pending</span>
                            </Link>
                          </li>
                          <li className="nk-menu-item">
                            <Link
                              to="/approved-transactions"
                              className="nk-menu-link"
                            >
                              <span className="nk-menu-text">Approved</span>
                            </Link>
                          </li>
                          <li className="nk-menu-item">
                            <Link to="/rejected-transactions" className="nk-menu-link">
                              <span className="nk-menu-text">Rejected</span>
                            </Link>
                          </li>
                        </ul>
                      </li>
                      
                  </ul>
                </div>
              </div>
              
              {/* User Profile Dropdown */}
              <div className="nk-header-tools">
                <ul className="nk-quick-nav">
                  <li className="dropdown user-dropdown" ref={dropdownRef}>
                    <button
                      type="button"
                      className="user-toggle"
                      onClick={toggleDropdown}
                    >
                      <div className="user-avatar">
                        {getUserInitials()}
                      </div>
                      <div className="user-info d-none d-md-block">
                        <div className="user-name">
                          {user?.name || 'Admin User'}
                        </div>
                        <div className="user-email">
                          {user?.email || 'admin@westgate.co.ke'}
                        </div>
                      </div>
                      <em className="icon ni ni-chevron-down ms-2" />
                    </button>
                    <div className="user-dropdown-menu">
                      <ul>
                        <li>
                          <div style={{ padding: '10px 16px', borderBottom: '1px solid #e5e9f2' }}>
                            <div style={{ fontWeight: 600, marginBottom: '4px' }}>
                              {user?.name || 'Admin User'}
                            </div>
                            <div style={{ fontSize: '12px', color: '#8094ae' }}>
                              {user?.email || 'admin@westgate.co.ke'}
                            </div>
                            <div style={{ fontSize: '11px', color: '#8094ae', marginTop: '4px' }}>
                              <em className="icon ni ni-user-circle" /> {user?.role || 'Administrator'}
                            </div>
                          </div>
                        </li>
                        <li>
                          <Link to="/dashboard">
                            <em className="icon ni ni-dashboard" />
                            <span>Dashboard</span>
                          </Link>
                        </li>
                        <li>
                          <button onClick={logout} className="text-danger">
                            <em className="icon ni ni-signout" />
                            <span>Sign Out</span>
                          </button>
                        </li>
                      </ul>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
  )
}

export default Navbar